import * as React from 'react';
import { Switcher } from '../../switcher/switcher';
import { ReturnMetricEnum } from '../../../../models/enums/return-metric-enum';
import { RETURN_METRIC_LABELS } from '../../../../models/constants/return-metric';
import { useReturnMetricColors } from './dashboard-return-metric';
import { Tooltip } from '../../tooltip/tooltip';

type DashboardReturnMetricSwitcherProps = {
    value: ReturnMetricEnum;
    onChange: (value: ReturnMetricEnum) => void;
    metrics?: ReturnMetricEnum[];
    size?: 'small' | 'default' | 'large';
    disabled?: boolean;
    disabledTooltip?: React.ReactNode;
};

export const DashboardReturnMetricSwitcher: React.FC<DashboardReturnMetricSwitcherProps> = ({
    value,
    onChange,
    metrics = Object.values(ReturnMetricEnum),
    size = 'default',
    disabled = false,
    disabledTooltip,
}) => {
    const colors = useReturnMetricColors();

    const switcher = (
        <Switcher
            value={value}
            size={size}
            activeBackgroundColor={colors[value]}
            onChange={onChange}
            disabled={disabled}
            options={metrics.map((metric) => ({
                value: metric,
                label: RETURN_METRIC_LABELS[metric],
            }))}
        />
    );

    return disabled && disabledTooltip ? (
        <Tooltip content={disabledTooltip} size="medium" block>
            {switcher}
        </Tooltip>
    ) : (
        switcher
    );
};
